import { render, staticRenderFns } from "./player.vue?vue&type=template&id=fd413dd6&scoped=true&"
import script from "./player.vue?vue&type=script&lang=js&"
export * from "./player.vue?vue&type=script&lang=js&"
import style0 from "./player.vue?vue&type=style&index=0&id=fd413dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd413dd6",
  null
  
)

export default component.exports